import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import Tooltip from '@material-ui/core/Tooltip';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import EditIcon from '@material-ui/icons/Edit';
import Paper from '@material-ui/core/Paper';
import DeleteIcon from '@material-ui/icons/Delete';
import { tableTdIconStyles1 } from "../../../config/styles";
import { StyledTableCell, StyledTableRow } from '../../atoms/table/tableStyles';
import { invokeGetService } from "../../../store/global/actions";
import CircularProgress from '@material-ui/core/CircularProgress';
import { StyledTableCellHead } from '../../atoms/table/tableStyles';


export default function ListSimulationProfiles({ setAction, entityId, type }) {
    // console.log("ListSimulationProfiles-------------------> ", {entityId, type})
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const [profiles, setProfiles] = useState([]);
    const [testcaseprofiles, setTestcaseprofiles] = useState([]);
    const currentUrl = window.location.href;

    const fetchprofiles = () => {
        setLoading(true);

        Promise.all([
            dispatch(invokeGetService('getBlueprintConstructs', [])),
            dispatch(invokeGetService(type === 'testcase' ? 'getTestcaseProfiles' : 'getTestsuiteProfiles', [entityId])),
        ]).then(([constructs, testcaseProfiles]) => {
            console.log('testcaseProfiles------>', testcaseProfiles)
            setProfiles(constructs?.data?.clusterlets.filter(cl => cl.type == 6) || [])
            setTestcaseprofiles(testcaseProfiles.data || [])
            setLoading(false)
        });
    }

    useEffect(() => {
        if(entityId != null || entityId != undefined) fetchprofiles();
    }, [entityId]);


    return (
        <>

            <TableContainer component={Paper} >
                <Table aria-label="customized table" >
                    <TableHead>
                        <TableRow>
                            <StyledTableCellHead align='center' > Profile</StyledTableCellHead>
                            <StyledTableCellHead align='center' > Description</StyledTableCellHead>
                            <StyledTableCellHead align='center' > Instance</StyledTableCellHead>
                            <StyledTableCellHead align='center' > Action   </StyledTableCellHead>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {loading ?
                            <StyledTableRow>
                                <StyledTableCell align={'center'} colSpan={10} component="td" style={{ padding: 15 }}>
                                    Loading... <CircularProgress size={15} style={{ color: '#000' }} />
                                </StyledTableCell>
                            </StyledTableRow>
                            : testcaseprofiles === undefined || testcaseprofiles?.length < 1 ?
                                <StyledTableRow>
                                    <StyledTableCell align={'center'} colSpan={10} component="td" style={{ padding: 15 }}>
                                        No profiles available.
                                    </StyledTableCell>
                                </StyledTableRow>
                                :
                                testcaseprofiles.map((profile, index) => (
                                    <StyledTableRow key={profile._id}>


                                        <StyledTableCell align={'center'} component="td" >
                                            {profiles.find(pr => pr._id == profile.profile_id) ? profiles.find(pr => pr._id == profile.profile_id).name : "'"}
                                        </StyledTableCell>

                                        <StyledTableCell align={'center'} component="td" >
                                            {profile.description ? profile.description : ""}
                                        </StyledTableCell>

                                        <StyledTableCell align={'center'} component="td" >
                                            {profile.instance}
                                        </StyledTableCell>

                                        <StyledTableCell align="center" style={{ "display": "flex", "justify-content": "center" }}>

                                            <Tooltip title="Edit profile">
                                                <EditIcon style={tableTdIconStyles1} color="primary" onClick={() => setAction({ action: 'edit_profile', id: profile._id, item: profile })} />
                                            </Tooltip>


                                            <Tooltip title="Delete profile">
                                                <DeleteIcon style={tableTdIconStyles1} color="error" onClick={() => setAction({ action: 'delete_profile', id: profile._id, item: profile, name:  profiles.find(pr => pr._id == profile.profile_id) ? profiles.find(pr => pr._id == profile.profile_id).name : "'"})} />
                                            </Tooltip>

                                        </StyledTableCell>

                                    </StyledTableRow>
                                ))}
                    </TableBody>
                </Table>
            </TableContainer>

        </>
    )

}
